import { cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils'

import { BaseButton, baseButtonCls, ButtonProps } from './BaseButton'

const clone1OnlyCls = cva('rounded-full', {
	variants: {
		visual: {
			default: '',
			secondary: 'border-blue',
			'secondary-inverted': '',
			soft: '',
			'soft-shadow': '',
			ghost: '',
			'ghost-accent': '',
			text: '',
		},
		size: {
			default:
				'type-body-medium px-6 has-[>svg]:type-body-small has-[>svg]:px-4 has-[>svg]:font-medium',
			large: 'px-8',
			icon: '',
			'icon-large': '',
		},
		pulsate: {
			true: '',
		},
	},
	defaultVariants: {
		visual: 'default',
		size: 'default',
	},
	compoundVariants: [
		{
			visual: 'default',
			size: 'icon',
			class: 'bg-grey hover:bg-black',
		},
		{
			visual: 'default',
			size: 'icon-large',
			class: 'bg-grey hover:bg-black',
		},
		{
			visual: 'secondary-inverted',
			size: 'large',
			class: 'border-1',
		},
	],
})

export const clone1ButtonCls: typeof baseButtonCls = (props) => {
	if (!props) {
		return cn(baseButtonCls(), clone1OnlyCls())
	}
	const { class: classProp, className, ...variantProps } = props
	return cn(
		baseButtonCls(variantProps),
		clone1OnlyCls(variantProps),
		classProp,
		className,
	)
}

export const Clone1Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ visual, size, pulsate, className, ...props }, ref) => {
		const computedClassName = cn(
			clone1ButtonCls({
				visual,
				size,
				pulsate,
			}),
			className,
		)

		return (
			<BaseButton
				ref={ref}
				{...props}
				visual={visual}
				size={size}
				pulsate={pulsate}
				className={computedClassName}
			/>
		)
	},
)
Clone1Button.displayName = 'Clone1Button'
